import React from "react";
import PageWrapper from "../../../component/home/HomeContentPage";
import {HomeContentId} from "../../../component/home/variable/HomeContentType";
import HomeSubscription from "../../../component/home/HomeSubscription";
import GradientSubscription1 from "../../../assets/svgs/home/graident_subscription_1.svg";
import GradientSubscription2 from "../../../assets/svgs/home/graident_subscription_2.svg";

const SubscriptionPage: React.FC = () => {
    return (
        <PageWrapper scrollId={HomeContentId.SUBSCRIPTION}
                     bgStyle={{position: "relative", overflow: "hidden", marginBottom: "auto"}}
                     className={"pt-[94px] lg:pt-[152px] pb-[94px]"}>
            <div className={"w-full flex justify-center z-10"}>
                <HomeSubscription />
            </div>
            <div className={"absolute bottom-[-215px] left-[-70px] rotate-[-4.7deg]"}>
                <img src={GradientSubscription1} alt="gardient" width={1199} height={288}/>
            </div>
            <div className={"w-[984px] h-[326px] absolute bottom-[-355px] right-[-164px] rotate-[-4.7deg]"}>
                <img src={GradientSubscription2} alt="gardient" width={984} height={326}/>
            </div>
        </PageWrapper>
    )
}

export default SubscriptionPage;
